import { createApp } from "vue"
import { Swiper, SwiperSlide } from "swiper/vue"
import { Navigation, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import ActionSheet from "../components/ActionSheet.vue"
import BudgetModal from "../components/BudgetModal.vue"
import { Modal } from "bootstrap"
import VueMask from '@devindex/vue-mask'

const app = createApp({
    components: {
        Swiper,
        SwiperSlide,
        ActionSheet,
        BudgetModal,
        Modal
    },
    data() {
        return {
            term: "",
            showCategoriesActionsheet: false,
            loadingSearch: false,
            suggestionsTab: "featured",
            tabs: [
                { label: "Destaques", value: "featured" },
                { label: "Mais Acessados", value: "popular" },
                { label: "Novidades", value: "new" },
            ],

            evaluationsSwiperRef: null,

            categoriesBreakpoints: {
                320: { slidesPerView: 2.5 },
                480: { slidesPerView: 4.5 },
                768: { slidesPerView: 7.5 },
                1024: { slidesPerView: 12 },
            },

            featuredCategoriesBreakpoints: {
                480: { slidesPerView: 1 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 5 },
            },

            evaluationsBreakpoints: {
                480: { slidesPerView: 1 },
                768: { slidesPerView: 1.6 },
                1024: { slidesPerView: 2.5 },
            },

            blogBreakpoints: {
                480: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            },

            budget: false,
            
            mapa: {
                nome: null,
                latitude: null,
                longitude: null,
                referencia: null,
                endereco: null
            }
        }
    },
    methods: {
        onSearch(ev) {
            this.loadingSearch = true
            window.location.href = window.routes.search.replace(
                "__termo",
                this.slugify(this.term)
            )
        },
        setSuggestionsTab(tab) {
            this.suggestionsTab = tab.value
        },
        onEvaluationsSwiper(swiperInstance) {
            this.evaluationsSwiperRef = swiperInstance
        },
        evaluationsGoNext() {
            this.evaluationsSwiperRef?.slideNext()
        },
        evaluationsGoPrev() {
            this.evaluationsSwiperRef?.slidePrev()
        },
        slugify(text) {
            return text
                .toString()
                .normalize("NFKD")
                .toLowerCase()
                .trim()
                .replace(/\s+/g, "-")
                .replace(/[^\w\-]+/g, "")
                .replace(/\-\-+/g, "-")
        },
        gotoUrl(url) {
            window.location.href = url
        },
        openMaps(empresa) {
            this.mapa = empresa
            const modal = new Modal(document.getElementById("mapsModal"))
            modal.show()
        }
    },
    setup() {
        return {
            Navigation,
            Pagination,
        }
    },
})

app.use(VueMask).mount("#homepage")
